import eventosMenu from './eventos/menu';
import contasEventosMenu from './contasEventos/menu';
import credenciamentoMenu from './credenciamento/menu';
import feiraMenu from './inscricoes/menu';
import landingPagesMenu from './landingpages/menu';

const menu = {
    label: 'Webster',
    icon: 'pi pi-fw pi-id-card',
    rules: [...eventosMenu.rules, ...contasEventosMenu.rules, ...credenciamentoMenu.rules, ...feiraMenu.rules, ...landingPagesMenu.rules],
    items: [eventosMenu, contasEventosMenu, credenciamentoMenu, feiraMenu, landingPagesMenu],
};

export default menu;
